import { backgrounds } from "./constants/backgrounds";

function PaintPins(ctx, canvas, board, coeffs) {
  ctx.fillStyle = "#6168af";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  for (let i = 0; i < board.length - 1; i++) {
    const row = board[i];
    for (let j = 0; j < row.length; j++) {
      const { x, y, r } = row[j];
      ctx.beginPath();
      ctx.arc(x, y, r, 0, Math.PI * 2);
      ctx.fillStyle = "#353752";
      ctx.fill();
    }
  }

  for (let i = board.length - 1; i < board.length; i++) {
    const row = board[i];
    const xrow = board[i - 2];
    for (let j = 0; j < xrow.length; j++) {
      let { y } = row[j];
      let { x } = xrow[j];
      let height, radius, font, rectX, rectY;
      ctx.beginPath();
      ctx.fillStyle = backgrounds[i - 8][j];
      // ctx.fillStyle = "#ffb000";
      // ctx.arc(x, y, 4 * 2, 0, Math.PI * 2);

      let width = 16;
      // +coeffs[j] >= 1000 ? (width = 20) : (width = 16);

      if (coeffs[j] === "1000") {
        coeffs[j] = "1k";
      }

      // i >= 12
      //   ? roundRect(ctx, x - 8, y - 7, width, 14, 7)
      //   : roundRect(ctx, x - 11.5, y - 9, 23, 18, 10);

      if (i >= 12) {
        rectX = x - 8;
        rectY = y - 7;
        height = 14;
        radius = 7;
        font = 6.6;
      } else {
        rectX = x - 11.5;
        rectY = y - 9;
        width = 23;
        height = 18;
        radius = 10;
        font = 9;
      }
      roundRect(ctx, rectX, rectY, width, height, radius);
      ctx.fill();
      ctx.font = `${font}px regularGT`;
      ctx.fillStyle = "#353752";
      ctx.fillText(coeffs[j], x, y);
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
    }
  }
}

export default PaintPins;

function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
  if (typeof stroke === "undefined") {
    stroke = true;
  }
  if (typeof radius === "undefined") {
    radius = 5;
  }
  if (typeof radius === "number") {
    radius = { tl: radius, tr: radius, br: radius, bl: radius };
  } else {
    var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
    for (var side in defaultRadius) {
      radius[side] = radius[side] || defaultRadius[side];
    }
  }
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(
    x + width,
    y + height,
    x + width - radius.br,
    y + height
  );
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
  if (fill) {
    ctx.fill();
  }
  // if (stroke) {
  //   ctx.stroke();
  // }
}
